import {useLocation, useNavigate, useParams} from "react-router";
import {AlertCircle} from "lucide-react";
import {useCampaign} from "@/campaigns/CampaignContextHooks.ts";
import {usePlayerView} from "@/player/PlayerViewHooks.ts";
import DetailPaneState from "@/components/management/DetailPaneState.tsx";
import SceneDetail from "@/scenes/SceneDetail.tsx";
import {useDeleteSceneMutation, useSceneQuery} from "@/scenes/SceneQueries.ts";

export default function SceneDetailRoute() {
    const {id} = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const {campaign, campaignPath} = useCampaign();
    const {display, displayScene} = usePlayerView();
    const query = useSceneQuery(id);
    const deleteMutation = useDeleteSceneMutation();
    const scene = query.data?.campaignId === campaign.id ? query.data : undefined;

    if (query.isPending) return <DetailPaneState title="Szene wird geladen…" loading/>;
    if (query.isError) return <DetailPaneState title="Szene konnte nicht geladen werden" onRetry={() => void query.refetch()}/>;
    if (!scene) return <DetailPaneState title="Szene nicht verfügbar"
                                         description="Die Szene gehört nicht zu dieser Kampagne."
                                         icon={<AlertCircle className="size-10"/>}/>;

    const edit = () => navigate({pathname: campaignPath(`scenes/${scene.id}/edit`), search: location.search});
    const remove = async () => {
        await deleteMutation.mutateAsync(scene.id);
        navigate({pathname: campaignPath("scenes"), search: location.search}, {replace: true});
    };

    return <SceneDetail key={scene.image.id}
                        scene={scene}
                        isDisplayed={display.display === "scene" && display.scene.id === scene.id}
                        onDisplay={() => void displayScene(scene)}
                        onEdit={edit}
                        onDelete={remove}/>;
}
